import { Component, EventEmitter, OnInit, Output, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, first, config, isEmpty, shareReplay } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { JEService } from 'src/app/services/je-services.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Table } from 'primeng/table';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-tank-stage2-approved',
  templateUrl: './tank-stage2-approved.component.html',
  styleUrls: ['./tank-stage2-approved.component.scss']
})
export class TankStage2ApprovedComponent implements OnInit {

  @ViewChild('tankTable', { static: true }) public tankDataTable: Table;

  num = 0;
  pondType = [
    { name: "Bricks Work" },
    { name: "Earth Work" },
  ];

  displayTankDialog2: boolean = false;
  wrongNotificationCheck2: boolean = true;
  submitEstimateFormStage2: FormGroup;
  submitFalseIntimateFormStage2: FormGroup;
  appID: any;
  items: any[];
  selectedStatus: any;
  selectedStatusFalseIntimation: any;
  //remarks: any;
  isSubmitted: boolean = false;
  isLoading = false;
  userId: any;
  stage: any;
  displayFileDialog: boolean;
  rotatableFilePath: any;
  pondList: any;
  public dialogData: any;
  public dialogData2: any;
  public tankData: any;
  // public pondData:any;
  stage2FalseIntimationremarks: any;
  stage2EstimateFormremarks: any;
  canEditPondData: boolean;
  actualSubsidy_Stage2: number;
  appId: number;
  pondSurveyStage2Data: any;
  longPosition: any;
  latPosition: any;
  PondVerDataStage2: any;
  // num: number;
  uploadOptions: any[];
  selectedCity1: any;
  //PondType:any;
  displayCameraComponent: boolean = false;
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();


  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: this.viewportToPixels('100vw') },
    height: { ideal: 500 },
  };
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  autoId: any;
  miPhysicalAppReqBody: any;
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  applicationNo: any;
  insertPondAttachments: any = [];
  displayCustom: boolean;
  activeIndex: number = 0;
  selectedRow: any;
  capturelist: Array<{ attachmentsDoc: any; documentType: any; }>;
  selectedPondType: any;
  Applicant_type: any;
  //selectedPondType: any;

  ipAddress: any = '000.000.000';
  XENdisplayCustom: boolean;
  XENactiveIndex: number = 0;
  selectedSurveyType: any
  xenLogin: boolean = false;
  jeLogin: boolean = false;
  sdoLogin: boolean = false;
  isDDAssociate: boolean = false;
  isJEEW: boolean = false;
  isDMICADA: boolean = false;
  isAdmin: boolean = false;
  adminUpdate: boolean = false;

  appVerificationItems: MenuItem[];
  appVerificationModel: any[];

  public loading: boolean = false;
  public subscriptions: any = [];
  public subjectSub: any;
  public selectedYear: any;

  public isDD_EW: boolean = false;
  public isJE_EW: boolean = false;
  public isDDTank: boolean = false;
  public noOfBeneficiary: any;

  SDOdisplayCustom: boolean;
  SDOactiveIndex: number = 0;

  public jeorxenLogin = false;
  public jegeolocationsarray: any[] = []
  public xengeolocationsarray: any = []
  sdogeolocationsarray: any = []

  public mapEnable: boolean = false;
  public mapEnableJE: boolean = false;
  public mapEnableXEN: boolean = false;
  public mapEnableSDO: boolean = false;

  public jeMapoverlays: any = [];
  public jeMapoptions: any;
  public xenMapoverlays: any = [];
  public xenMapoptions: any;
  public sdoMapoverlays: any = [];
  public sdoMapoptions: any;

  public coordinateError: any;

  public landArea: number;
  public jeSurveyLandArea: number;
  public xenSurveyLandArea: number;
  public sdoSurveyLandArea: number;

  public isGPSError: boolean = false;
  public refreshLocation: any;
  
  public viewWorkFlowAllStatus: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService,
    private pondService: JEService,
    private tokenService: TokenService,
    private deptDashBoardService: DepartmentDashboardService,
    private sanitizer: DomSanitizer,
    public router: Router,
    private route: ActivatedRoute,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService,
    private cdr: ChangeDetectorRef,
  ) {
    const tokenData = sessionStorage.getItem('token') ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'))) : {}

    if (tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')) {
      this.xenLogin = true;
      this.jeorxenLogin = true
    }
    else if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.jeLogin = true;
      this.jeorxenLogin = true;
    }
    else if (tokenData && tokenData.role == 'SDO') {
      this.sdoLogin = true
    }
    else if (tokenData && (tokenData.role == 'DD Associate')) {
      this.isDDAssociate = true
    }
    else if (tokenData && (tokenData.role == 'DMICADA')) {
      this.isDMICADA = true
    }
    else if (tokenData && (tokenData.role.toLowerCase() == 'admin')) {
      this.isAdmin = true
    }
    else if (tokenData && ((tokenData.role).toLowerCase() == 'je-ew')) {
      this.isJEEW = true
    }
    else if (tokenData && ((tokenData.role).toLowerCase() == 'ddtank')) {
      this.isDDTank = true
    }
    else if (tokenData && ((tokenData.role).toLowerCase() == 'dd-ew')) {
      this.isDD_EW = true
    }
    else if (tokenData && ((tokenData.role).toLowerCase() == 'je-ew')) {
      this.isJE_EW = true
    }
  }


  //pondData: PondDataModel= new PondDataModel();
  ngOnInit(): void {
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];

    if (((this.router.url.startsWith('/je')) || this.router.url.startsWith('/sdo')) || (this.router.url.startsWith('/xen'))) {
      this.canEditPondData = false;
    }
    else {
      this.canEditPondData = true;
    }
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Tank_Stage_export');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Tank_Stage_export'
          );
        },
      },
    ];
    this.getIP();
    this.getGPSCoordinates();
    this.submitEstimateFormStage2 = this._fb.group({
      topSizeLength: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      topSizeBreadth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      bottomSizeLength: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      bottomSizeBreadth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      depth: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      typeOfPond: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      toalCostOfWaterTank: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      totalAmountOfSubsidy: ['', Validators.required],
      AssistancePaidAtStage1: [{ value: '', disabled: this.canEditPondData }, Validators.required],
      amountOfTotalSubsidy: [{ value: '' }, Validators.required],
      //estimateCopy: ['', Validators.required],
      // estimateCopy:[''], 
      // latitude: [{ value: '', disabled: true }],
      // longitude: [{ value: '', disabled: true }],
      measurementBookCopyPathStage2: [''],
      // remarks: ['', Validators.required],
      StateShare_Amount: [{ value: '', disabled: true }],
      CenterShare_Amount: [{ value: '', disabled: true }],
      ABY: [{ value: '', disabled: true }],
      TopUp: [{ value: '', disabled: true }],
      Coverage_Area: [{ value: '', disabled: true }],
    });
    this.submitFalseIntimateFormStage2 = this._fb.group({
      uploadThePhotoTaken: ['', Validators.required],
      //remarks: ['', Validators.required],
    });
    let actionId: number;
    if ((this.router.url.split('/')[1] == 'department') ||
      (this.router.url.split('/')[1] == 'admin') ||
      this.router.url.split('/')[1] == 'ew-je' ||
      this.router.url.split('/')[1] == 'ew-department') {
      // actionId = 30;
      actionId = 11;
    } else {
      actionId = 10; // Do not Change, it is fixed for Farmer Application Verifications
    }
    //let actionId = 10; // Do not Change, it is fixed for Farmer Application Verifications
    this.images = this.insertPondAttachments;
    //this.selectedPondType=this.pondType;

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
        }
      });

  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {


        this.selectedYear = res;
        this.loadData();
        this.tankDataTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy() {
    this.displayCameraComponent = false;

    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadData() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    if (this.userId == 'Admin2') {
      this.userId = 'Admin';
    }
    this.stage = 2;
    // this.loader.start();
    this.loading = true;
    let sub = this.pondService
      .getFarmerApplicationForPondVerStage2(this.userId, 'Approved', this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved)', '', new Date(), 'Success');

          this.tankData = data;

          if (this.tankData && this.tankData?.length > 0) {
            this.tankData.forEach(e => {
              e.AssignedDate = new Date(e?.AssignedDate);
              e.ActionDate = new Date(e?.ActionDate);
            })
          }


          this.appVerificationModel = this.tankData;
          // this.loader.close();
          this.loading = false;
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved)', '', new Date(), err);

          this.tankData = [];
          if (err == 'Data not Found!') {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: err,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        },
      });

    this.subscriptions.push(sub);
  }

  refreshTable() {
    this.loadData();
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'Applicant Type': d.Applicant_type,
          'App type': d.FarmerName,
          'District': d.district,
          'block': d.block,
          "Village": d.village,
          'Total Area': d.Total_Area,
          'Age Of Application': d.AgeOfApplication,
          'Pending Completed Days': d.PendingCompletedDays,
          'Land Detail': d.LandDetail,
          'status': d.status,
          'Remarks': d.remarks,
          'Current Status': d.Status_Ar,
          'User Type': d.UserType
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'Applicant_type', header: 'Applicant type' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'district', header: 'district' },
      { field: 'block', header: 'block' },
      { field: 'village', header: 'village' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'status', header: 'Status' },
      { field: 'remarks', header: 'Remarks' },
      { field: 'Status_Ar', header: 'Current Status' },
      { field: 'UserType', header: 'User Type' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, { styles: { fontSize: 6 } });

        doc.save(`${filename}.pdf`);
      });
    });
  }

  get tankFormControlsStage2() {
    return this.submitEstimateFormStage2.controls;
  }

  get falseIntimationFormControlsStage2() {
    return this.submitFalseIntimateFormStage2.controls;
  }


  onPondTypeSelected(event) {

    this.selectedPondType = event.value;
  }

  public prev = false;
  public XENprev = false;
  public SDOprev = false;
  selectTankRowData(product) {
    // this.selectedSurveyType = 1
    this.dialogData2 = [product];
    this.appID = product.appID;
    this.Applicant_type = product.Applicant_type;
    this.noOfBeneficiary = product?.NoOfBeneficiary;

    if (((this.router.url.startsWith('/je')) || this.router.url.startsWith('/sdo')) || (this.router.url.startsWith('/xen'))) {
      this.submitEstimateFormStage2.disabled ? this.submitEstimateFormStage2.enable() : this.submitEstimateFormStage2.enable();
      this.submitFalseIntimateFormStage2.disabled ? this.submitFalseIntimateFormStage2.enable() : this.submitFalseIntimateFormStage2.enable();
      this.canEditPondData = false;
    }

    this.appId = this.appID;

    this.onOpenDialog();
    if (this.jeLogin) {
      this.selectedSurveyType = 1;
      this.populateAndCalculateData(null);
    }

    this.loader.start();
    this.pondService
      .getPondVerDataByAppIdStage2(this.appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.setupGeoLocations(data);
          this.loader.close();

          this.PondVerDataStage2 = data;
          this.stage2EstimateFormremarks = data.Remarks;
          if (this.PondVerDataStage2.SurveyType == 0) {
            this.selectedSurveyType = '0'
          } else {
            this.selectedSurveyType = 1
          }
          
          // if(this.PondVerDataStage2.Table.length>0)
          // {
          if (this.jeLogin) {
            for (let index = 0; index < this.PondVerDataStage2?.listImagePathJE?.length; index++) {
              this.PondVerDataStage2.listImagePathJE[index].attachmentRawUrl = this.PondVerDataStage2.listImagePathJE[index].ImagePath
              this.PondVerDataStage2.listImagePathJE[index].displayName = this.PondVerDataStage2.listImagePathJE[index].DocumentType
              this.PondVerDataStage2.listImagePathJE[index].attachment = this.PondVerDataStage2.listImagePathJE[index].ImagePath
            }
            this.insertPondAttachments = this.PondVerDataStage2?.listImagePathJE;
          }
          if (this.sdoLogin) {
            for (let index = 0; index < this.PondVerDataStage2?.listImagePathSDO?.length; index++) {
              this.PondVerDataStage2.listImagePathSDO[index].attachmentRawUrl = this.PondVerDataStage2.listImagePathSDO[index].ImagePath
              this.PondVerDataStage2.listImagePathSDO[index].displayName = this.PondVerDataStage2.listImagePathSDO[index].DocumentType
              this.PondVerDataStage2.listImagePathSDO[index].attachment = this.PondVerDataStage2.listImagePathSDO[index].ImagePath

            }
            this.insertPondAttachments = this.PondVerDataStage2?.listImagePathSDO;
          }
          if (this.xenLogin) {
            for (let index = 0; index < this.PondVerDataStage2?.listImagePathXEN?.length; index++) {
              this.PondVerDataStage2.listImagePathXEN[index].attachmentRawUrl = this.PondVerDataStage2.listImagePathXEN[index].ImagePath
              this.PondVerDataStage2.listImagePathXEN[index].displayName = this.PondVerDataStage2.listImagePathXEN[index].DocumentType
              this.PondVerDataStage2.listImagePathXEN[index].attachment = this.PondVerDataStage2.listImagePathXEN[index].ImagePath

            }
            this.insertPondAttachments = this.PondVerDataStage2?.listImagePathXEN;
          }
          // sessionStorage.setItem('pondData', JSON.stringify(data));

          this.prev = Array.isArray(this.PondVerDataStage2?.listImagePathJE) && this.PondVerDataStage2?.listImagePathJE.length > 0;
          this.XENprev = Array.isArray(this.PondVerDataStage2?.listImagePathXEN) && this.PondVerDataStage2?.listImagePathXEN.length > 0;
          this.SDOprev = Array.isArray(this.PondVerDataStage2?.listImagePathSDO) && this.PondVerDataStage2?.listImagePathSDO.length > 0;
          this.populateAndCalculateData(data);


          // }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });

          this.loader.close();
          this.setupGeoLocations(null);
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-1 Survey(Approved) Action Start', this.appID, new Date(), err);
        
          if(!this.jeLogin){
            setTimeout(() => {
              this.onCloseDialog();
            }, 1500);
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: `Data Error! ${err}`,
            });
          }
        },
      });

    // if(product.Stage==2)
    //   {
    // this.dialogData2 = [product];
    // this.appID = product.appID;
    // this.displayTankDialog2 = true;
    // }
    // else{
    //   console.log("error");
    // }
    this.loader.close();
  }

  setupGeoLocations(data) {
    // data = {
    //   ...data,
    //   listGPSCoordinatesJE : [[]],
    //   listGPSCoordinatesXEN : [[]],
    // }
    this.mapEnableJE = false;
    this.mapEnableXEN = false;
    this.jeMapoverlays = [];
    this.xenMapoverlays = [];
    // this.preEstimateCoordinates = data.listGPSCoordinatesPreEst;
    this.jegeolocationsarray = data?.listGPSCoordinatesJE ? data?.listGPSCoordinatesJE : [[]];
    this.xengeolocationsarray = data?.listGPSCoordinatesXEN ? data?.listGPSCoordinatesXEN : [[]];
    this.sdogeolocationsarray = data?.listGPSCoordinatesSDO ? data?.listGPSCoordinatesSDO : [[]];
    // this.preEstimationGeolocationsArray = data?.listGPSCoordinatesPreEst;


    // this.preEstimateCoordinates = this.preEstimateCoordinates.map((array, index) => {
    //   return array.map((data) => ({
    //     CornerID: data.CornerID,
    //     latitude: data.Latitude,
    //     longitude: data.Longitude,
    //     lat: data.Latitude,
    //     lng: data.Longitude,
    //   }))
    // })

    if (data?.listGPSCoordinatesJE && data?.listGPSCoordinatesJE.length > 0) {
      data.listGPSCoordinatesJE = data?.listGPSCoordinatesJE.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })

      this.jegeolocationsarray = data?.listGPSCoordinatesJE;
    }

    if (data?.listGPSCoordinatesSDO && data?.listGPSCoordinatesSDO.length > 0) {
      data.listGPSCoordinatesSDO = data.listGPSCoordinatesSDO.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })

      this.sdogeolocationsarray = data?.listGPSCoordinatesSDO;
      // sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));
    }

    if (data?.listGPSCoordinatesXEN && data?.listGPSCoordinatesXEN.length > 0) {
      data.listGPSCoordinatesXEN = data.listGPSCoordinatesXEN.map((array, tableIndex) => {
        return array.map((val, index) => ({
          latitude: val.Latitude ? val.Latitude : val.latitude,
          longitude: val.Longitude ? val.Longitude : val.longitude,
          lat: val.Latitude ? val.Latitude : val.latitude,
          lng: val.Longitude ? val.Longitude : val.longitude,
          CornerID: val.CornerID ? val.CornerID : val.cornerID,
          cornerID: val.CornerID ? val.CornerID : val.cornerID
        }))
      })
      this.xengeolocationsarray = data?.listGPSCoordinatesXEN;
      // sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
    }


    if (this.jegeolocationsarray && this.jegeolocationsarray?.[0].length > 0) {
      this.mapEnableJE = true;
      this.jeMapoptions.center = this.jegeolocationsarray[0][0];
      this.jeMapoverlays = [];
      this.jegeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.addMarkers(row, index, tableIndex)
        })
      });
      this.addOverlay()
    }

    if (this.sdogeolocationsarray && this.sdogeolocationsarray?.[0].length > 0) {
      this.mapEnableSDO = true;
      this.sdoMapoptions.center = this.sdogeolocationsarray[0][0];
      this.sdoMapoverlays = [];
      this.sdogeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.sdoAddMarkers(row, index, tableIndex)
        })
      });
      this.sdoAddOverlay()
    }

    if (this.xengeolocationsarray && this.xengeolocationsarray?.[0].length > 0) {
      this.mapEnableXEN = true;
      this.xenMapoptions.center = this.xengeolocationsarray[0][0];
      this.xenMapoverlays = [];
      this.xengeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.xenAddMarkers(row, index, tableIndex)
        })
      });
      this.xenAddOverlay()
    }

  }

  onOpenDialog() {
    this.viewWorkFlowAllStatus = false;
    this.displayTankDialog2 = true;
    this.selectedSurveyType = 1;

    // if (this.selectedSurveyType == 1) {
    let val = '';
    if (this.jeLogin) {
      val = 'jeLogin';
      this.jegeolocationsarray = [];
      this.refreshLocation = setInterval(() => {
        this.onRefreshCurrentLocation(val);
      }, 5000);
    } else if (this.xenLogin) {
      val = 'xenLogin';
      this.xengeolocationsarray = [];
    } else if (this.sdoLogin) {
      val = 'sdoLogin'
      this.sdogeolocationsarray = [];
    }

    this.onDialogOpenMap();
  }

  onDialogOpenMap() {
    this.jeMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.xenMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.sdoMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    // this.preEstimateMapoptions = {
    //   center: { lat: 29.0588, lng: 76.0856 },
    //   zoom: 17,
    //   mapTypeId: google.maps.MapTypeId.SATELLITE
    // };
    if (this.jeLogin) {
      this.refreshLocation = setInterval(() =>
        this.onRefreshCurrentLocation('jeLogin'), 5000);
    }

    // this.getGPSCoordinates();
  }


  onCloseDialog() {
    this.submitEstimateFormStage2.reset();
    this.displayTankDialog2 = false;
    this.isSubmitted = false;
    this.insertPondAttachments = [];
    // if(this.isSubmitted==true)
    // {
    //   this.submitEstimateFormStage2.reset();
    //   this.displayTankDialog2 = false;
    // }
    this.stage2EstimateFormremarks = '';

    if (this.refreshLocation) {
      clearTimeout(this.refreshLocation);
    }
  }

  onUpload(event, formcontrol, uploadElement, step) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    if (step == 1) {
      this._personalDetalSer.uploadFile(data, this.appId, formcontrol).subscribe((resp: any) => {
        if (resp.data) {
          // console.log(resp.data,"resp.data----imgggggg")
          this.tankFormControlsStage2.measurementBookCopyPathStage2.setValue(resp.data);
          this.PondVerDataStage2.MeasurementCopy = resp.data;
        }
        if (resp.statusCode == 200) {
          this.submitEstimateFormStage2.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
      uploadElement.clear();
    }
    else {
      this._personalDetalSer.uploadFile(data, this.appId, formcontrol).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          this.submitFalseIntimateFormStage2.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
      uploadElement.clear();
    }
  }


  PostFalseIntimate(reqBody1) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody1))
    }

    this.loader.start();
    this.pondService
      .PondFalseIntimation(reqBodyAfterEncypt)
      .pipe()
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved) Action Submit(False Intimate)', reqBody1?.appID, new Date(), data.toString(), reqBody1);

          this.loader.close();

          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Pond false Intimation Added Successfully',
            });
            this.onCloseDialog();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${data}`,
            });
          }
          // console.log('POST VENDOR POND FALSE INTIMATION SUCCESS', data);

        },
        error: (err) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved) Action Submit(False Intimate)', reqBody1?.appID, new Date(), err, reqBody1);

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: `${err}`,
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Pond false Intimation Added Successfully',
        //   });
        // },
      });
  }



  submitFalseIntimateStage2() {
    this.isSubmitted = true;

    if (this.submitFalseIntimateFormStage2.get('uploadThePhotoTaken').value == '') {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Please Upload Photo',
      });
      return;
    }

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let userId = JSON.parse(payload)?.sub;
    let reqBody1: any = {
      appID: this.appID,
      stage: "2",
      status: this.selectedStatusFalseIntimation.flag,
      terminalID: this.ipAddress,
      networkID: this.ipAddress,
      //remarks: this.submitFalseIntimateFormStage2.get('remarks').value,
      photoPath: this.submitFalseIntimateFormStage2.get('uploadThePhotoTaken').value,
      userID: this.userId,
      remarks: this.stage2FalseIntimationremarks ? this.stage2FalseIntimationremarks : '',
    };
    this.PostFalseIntimate(reqBody1)
    //this.onCloseDialog();
  }

  submitEstimateStage2() {
    this.isSubmitted = true;
    if (this.submitEstimateFormStage2.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please fill all the required fields'
      });
      return;
    }

    // console.log('Image List', this.images);
    // console.log('Document List', this.insertPondAttachments);
    let isValid = true;
    if ((this.router.url.startsWith('/je') || (this.xenLogin && this.selectedSurveyType === 1) || (this.sdoLogin && this.selectedSurveyType === 1)) && this.selectedStatus?.flag == 'A') {
      if (!this.insertPondAttachments || this.insertPondAttachments.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Images are Mandatory' });
        return;
      }
      // this.capturelist = [{
      //   "attachmentsDoc": this.insertPondAttachments[0].attachment,
      //   "documentType": this.insertPondAttachments[0].displayName,
      // }]
    }
    if (!this.stage2EstimateFormremarks) {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Remarks are required' });
      return;
    }
    // let body = [];
    // this.insertPondAttachments.forEach(document => {
    //   body.push({
    //     "attachmentsDoc": document?.attachment,
    //     "documentType": document?.displayName,
    //   })
    // })          
    //   console.log("body",body);

    //   this.insertPondAttachments=body;

    if ((this.submitEstimateFormStage2.valid && this.selectedStatus?.flag == 'A') || this.selectedStatus?.flag == 'RP' || this.selectedStatus?.flag == 'R' || this.selectedStatus?.flag == 'MR'  || this.selectedStatus?.flag == 'RB' || this.selectedStatus?.flag == 'RPJE' || this.selectedStatus?.flag == 'RPJE' || this.selectedStatus?.flag != null || this.selectedStatus?.flag != undefined || this.selectedStatus?.flag != '') {
      this.capturelist = []
      if (this.insertPondAttachments && this.insertPondAttachments.length > 0) {
        for (let index = 0; index < this.insertPondAttachments.length; index++) {
          let obj = {
            attachmentsDoc: this.insertPondAttachments[index].attachment,
            documentType: this.insertPondAttachments[index].displayName,
          }
          this.capturelist.push(obj)
        }
      }

      let geoCoordinateError = false;
      if (this.jeLogin && this.selectedSurveyType == 1 && this.selectedStatus?.flag == 'A') {

        this.jegeolocationsarray.forEach((array, index) => {
          if (array.length < 4) {
            this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
            });
            geoCoordinateError = true;
            return;
          }
        })
      } else if (this.sdoLogin && this.selectedSurveyType == 1 && this.selectedStatus?.flag == 'A') {

        this.sdogeolocationsarray.forEach((array, index) => {
          if (array.length < 4) {
            this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
            });
            geoCoordinateError = true;
            return;
          }
        })

        if (this.jegeolocationsarray.length != 0 && this.jegeolocationsarray[0].length != 0) {
          let jeArray: any = this.jegeolocationsarray;
          const jeMergedArray = jeArray.flat();

          let sdoArray: any = this.sdogeolocationsarray;
          const sdoMergedArray = sdoArray.flat();

          let isPolygonPositionError = false;
          isPolygonPositionError = this.verifyCoordinates(jeMergedArray, sdoMergedArray, 'sdoLogin');
          if (isPolygonPositionError) {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
            geoCoordinateError = true;
            return;
          }
        }

      } else if (this.xenLogin && this.selectedSurveyType == 1 && this.selectedStatus?.flag == 'A') {

        this.xengeolocationsarray.forEach((array, index) => {
          if (array.length < 4) {
            this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`;
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: `Please provide atleast 4 GPS Coordinates for polygon ${index + 1}`,
            });
            geoCoordinateError = true;
            return;
          }
        })

        let isPolygonPositionError = false;
        if (this.jegeolocationsarray.length != 0 && this.jegeolocationsarray[0].length != 0) {
          let jeArray: any = this.jegeolocationsarray;
          const jeMergedArray = jeArray.flat();

          let xenArray: any = this.xengeolocationsarray;
          const xenMergedArray = xenArray.flat();

          isPolygonPositionError = this.verifyCoordinates(jeMergedArray, xenMergedArray, 'xenLogin');
          if (isPolygonPositionError) {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
            geoCoordinateError = true;
            return;
          }
        }

      }

      if (geoCoordinateError) {
        return;
      }

      let surveyAttachments = [[]];
      if (this.jeLogin) {
        surveyAttachments = this.jegeolocationsarray;
      } else if (this.xenLogin) {
        surveyAttachments = this.xengeolocationsarray;
      } else if (this.sdoLogin) {
        surveyAttachments = this.sdogeolocationsarray;
      }

      this.isLoading = true;
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      let userId = JSON.parse(payload)?.sub;
      let reqBody: any = {
        appID: this.appID,
        stageType: 2,
        userID: userId,
        totalAmtStage2: this.num.toString(),
        // stateShare_Amount:this.actualSubsidy_Stage2 *0.40,
        // centerShare_Amount:this.actualSubsidy_Stage2 *0.60,
        stateShare_Amount: 0,
        centerShare_Amount: 0,
        ABY: 0,
        TopUp: 0,
        networkId: this.ipAddress,
        terminalId: this.ipAddress,
        //actualSubsidy_Stage2:0,
        assistancePaidAtStage2: this.num.toString(),
        status: this.selectedStatus.flag,
        topLength: this.submitEstimateFormStage2.get('topSizeLength').value,
        topBreadth: this.submitEstimateFormStage2.get('topSizeBreadth').value,
        topSize: `${this.submitEstimateFormStage2.get('topSizeLength').value *
          this.submitEstimateFormStage2.get('topSizeBreadth').value
          }`,
        bottomLength: this.submitEstimateFormStage2.get('bottomSizeLength').value,
        bottomBreadth: this.submitEstimateFormStage2.get('bottomSizeBreadth').value,
        bottomSize: `${this.submitEstimateFormStage2.get('bottomSizeLength').value *
          this.submitEstimateFormStage2.get('bottomSizeBreadth').value
          }`,
        depth: this.submitEstimateFormStage2.get('depth').value,
        typeOfPond: this.submitEstimateFormStage2.get('typeOfPond').value,
        // tankLat: this.submitEstimateFormStage2.get('latitude').value != "" ? this.submitEstimateFormStage2.get('latitude').value : this.latPosition != null ? this.latPosition : 0,
        // tankLng: this.submitEstimateFormStage2.get('longitude').value != "" ? this.submitEstimateFormStage2.get('longitude').value : this.longPosition != null ? this.longPosition : 0,
        totalEstimatedCost: this.submitEstimateFormStage2.get('toalCostOfWaterTank').value,
        totalEstimatedSubsidy: this.submitEstimateFormStage2.get('totalAmountOfSubsidy').value,
        actualSubsidy_Stage2: this.submitEstimateFormStage2.get('amountOfTotalSubsidy').value,
        measurementCopy: this.submitEstimateFormStage2.get('measurementBookCopyPathStage2').value,
        // remarks: this.submitEstimateFormStage2.get('remarks').value,
        remarks: this.stage2EstimateFormremarks,
        insertPondAttachments: this.capturelist,
        surveyType: this.selectedSurveyType,
        insertSurveyGPSCoordiantes: surveyAttachments,
      };
      // console.log(reqBody, 'reqBody')
      this.postVendorPondEstimate(reqBody);
      //this.onCloseDialog();
    }
  }

  verifyCoordinates(coordinates1, coordinates2, loginType) {
    let element1coordinatelat = 0
    let element1coordinatelng = 0
    let element2coordinatelat = 0
    let element2coordinatelng = 0
    for (let index = 0; index < coordinates1.length; index++) {
      element1coordinatelat = element1coordinatelat + coordinates1[index].latitude;
      element1coordinatelng = element1coordinatelng + coordinates1[index].longitude;
    }
    for (let index = 0; index < coordinates2.length; index++) {
      element2coordinatelat = element2coordinatelat + coordinates2[index].latitude;
      element2coordinatelng = element2coordinatelng + coordinates2[index].longitude;
    }
    const x1latitude = element1coordinatelat / coordinates1.length
    const y1logitude = element1coordinatelng / coordinates1.length
    const x2latitude = element2coordinatelat / coordinates2.length
    const y2logitude = element2coordinatelng / coordinates2.length
    let distance = this.distance(x1latitude, y1logitude, x2latitude, y2logitude);
    if (distance > 50){
      return true;
    }else {
      return false;
    }
  }

  distance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // metres
    const radlat1 = lat1 * Math.PI / 180; // radlat1, radlat2 in radians
    const radlat2 = lat2 * Math.PI / 180;
    const radlon1 = (lat2 - lat1) * Math.PI / 180;
    const radlon2 = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(radlon1 / 2) * Math.sin(radlon1 / 2) +
      Math.cos(radlat1) * Math.cos(radlat2) *
      Math.sin(radlon2 / 2) * Math.sin(radlon2 / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    return d
  }

  wrongNotification2(submitEstimateFormStage2) {
    this.wrongNotificationCheck2 = !this.wrongNotificationCheck2;

    if (!this.wrongNotificationCheck2) {
      this.selectedStatusFalseIntimation = this.items[1];
    }

    submitEstimateFormStage2 = false;
  }

  @ViewChild('myname') myname: ElementRef;
  rotationAmount = 0;
  scalingAmount = 1;
  transformImage(direction, scale) {
    if (direction) {
      this.rotationAmount += direction == 'left' ? -90 : 90;
    }
    if (scale) {
      this.scalingAmount += scale == 'zoom-out' ? -0.1 : 0.1;
    }
    this.myname.nativeElement.style.transform = `rotate(${this.rotationAmount}deg) scale(${this.scalingAmount})`;
  }
  openFileDialog(filePath) {
    this.rotatableFilePath = filePath;
    this.displayFileDialog = true;
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.rotatableFilePath)
  }
  onCloseFileDialog() {
    this.displayFileDialog = false;
  }

  numberEquals(num1, num2) {
    return Number(num1) == Number(num2);
  }
  postVendorPondEstimate(reqBody) {

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.pondService
      //.vendorPondEstimate(reqBody)
      .pondSurveyStage2(reqBodyAfterEncypt)
      .pipe()
      .subscribe({
        next: (data: any) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved) Action Submit', reqBody?.appID, new Date(), data.toString(), reqBody);
          this.loader.close();
          //this.pondData=data;
          this.pondSurveyStage2Data = data;
          if (data == "S:Successfully Submitted" || data == "S:Successfully Updated") {
            // this.displayTankDialog2 = false;
            this.onCloseDialog();
            // this.loadData();
            // if(this.tankData?.length>0){
            //   let index= this.tankData.findIndex(e=>{return e.appID==reqBody.appID});
            //   let index1= this.tankDataTable.filteredValue.findIndex(e=>{return e.appID==reqBody.appID})
            //   this.tankData.splice(index,1)
            //   this.tankDataTable.filteredValue.splice(index1,1)
            //   this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
            // }
            // this.loadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data.toString(),
            });

          }
          else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data.toString(),
            });
          }

        },
        error: (err) => {
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-2 Survey(Approved) Action Submit', reqBody?.appID, new Date(), err, reqBody);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  populateAndCalculateData(data) {
    this.tankFormControlsStage2.topSizeLength.setValue(data?.topLength);
    this.tankFormControlsStage2.topSizeBreadth.setValue(data?.topBreadth);
    // this.tankFormControlsStage2.latitude.setValue(this.latPosition);
    // this.tankFormControlsStage2.longitude.setValue(this.longPosition);
    this.tankFormControlsStage2.toalCostOfWaterTank.setValue(data?.TotalEstimatedCost);
    this.tankFormControlsStage2.depth.setValue(data?.depth);
    // this.onPondTypeSelected({ value: this.selectedPondType });
    this.tankFormControlsStage2.typeOfPond.setValue(data?.TypeOfPond);
    // this.tankFormControlsStage2.typeOfPond.setValue(data?.TypeOfPond);
    this.tankFormControlsStage2.totalAmountOfSubsidy.setValue(data?.TotalEstimatedSubsidy);
    if (this.jeLogin && (data?.MeasurementCopy == "0" || data?.MeasurementCopy == null)) {
      this.tankFormControlsStage2.measurementBookCopyPathStage2.setValue(data?.estimateCopy_Stage1);
    } else {
      this.tankFormControlsStage2.measurementBookCopyPathStage2.setValue(data?.MeasurementCopy);
    }
    this.tankFormControlsStage2.bottomSizeLength.setValue(data?.bottomLength);
    this.tankFormControlsStage2.bottomSizeBreadth.setValue(data?.bottomBreadth);
    this.tankFormControlsStage2.amountOfTotalSubsidy.setValue(data?.ActualSubsidy_Stage2);
    this.tankFormControlsStage2.AssistancePaidAtStage1.setValue(data?.AssistancePaidAtStage1);
    // console.log(this.PondVerDataStage2,"PondVerDataStage2")

    if(this.isDD_EW || this.isJE_EW || this.isDDTank || this.isAdmin){
      this.tankFormControlsStage2.StateShare_Amount.setValue(data?.StateShare_Amount);
      this.tankFormControlsStage2.CenterShare_Amount.setValue(data?.CenterShare_Amount);
      this.tankFormControlsStage2.TopUp.setValue(data?.TopUp);
      this.tankFormControlsStage2.ABY.setValue(data?.ABY);
      this.tankFormControlsStage2.Coverage_Area.setValue(data?.Coverage_Area);
    }
  }

  get hasPrevAttachments() {
    return Array.isArray(this.PondVerDataStage2?.listImagePath) && this.PondVerDataStage2?.listImagePath[0].length > 0
  }
  pondSurveyStage2(reqBody) {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let body = [];
    let element =
    {
      "ActualSubsidy_Stage1": this.PondVerDataStage2?.ActualSubsidy_Stage1,
      "appID": this.PondVerDataStage2?.App_ID,
      "centerShare_Amount": this.PondVerDataStage2?.CenterShare_Amount,
      "remarks": this.PondVerDataStage2?.Remarks,
      "stateShare_Amount": this.PondVerDataStage2?.StateShare_Amount,
      "volumeEarthWork": this.PondVerDataStage2?.VolumeEarthWork,
      "bottomBreadth": this.PondVerDataStage2?.bottomBreadth,
      "bottomLength": this.PondVerDataStage2?.bottomLength,
      "bottomSize": this.PondVerDataStage2?.bottomSize,
      "typeOfPond": this.PondVerDataStage2?.TypeOfPond,
      "depth": this.PondVerDataStage2?.depth,
      "measurementCopy": this.PondVerDataStage2?.MeasurementCopy,
      "totalEstimatedCost": this.PondVerDataStage2?.TotalEstimatedCost,
      "topBreadth": this.PondVerDataStage2?.topBreadth,
      "topLength": this.PondVerDataStage2?.topLength,
      "topSize": this.PondVerDataStage2?.topSize,
      // "totalBilledAmount": parseFloat(this.PondVerDataStage2?.TotalBilledAmount),
      "tankLat": this.PondVerDataStage2?.tankLat ? this.PondVerDataStage2?.tankLat : this.latPosition,
      "tankLng": this.PondVerDataStage2?.tankLng ? this.PondVerDataStage2?.tankLng : this.longPosition,
      "actualSubsidy_Stage2": this.PondVerDataStage2?.ActualSubsidy_Stage2,
      "insertPondAttachments": this.PondVerDataStage2?.listImagePath,


      //"ActualSubsidy_Stage1": this.PondVerDataStage2?.ActualSubsidy_Stage1,
      //  "appID": this.PondVerDataStage2?.App_ID,
      //  "CenterShare_Amount": this.PondVerDataStage2?.CenterShare_Amount,
      //  "Remarks": this.PondVerDataStage2?.Remarks,
      //  "StateShare_Amount": this.PondVerDataStage2?.StateShare_Amount,
      //  "VolumeEarthWork": this.PondVerDataStage2?.VolumeEarthWork,
      //  "bottomBreadth": this.PondVerDataStage2?.bottomBreadth,
      //  "bottomLength": this.PondVerDataStage2?.bottomLength,
      //  "bottomSize": this.PondVerDataStage2?.bottomSize,
      //  "depth": this.PondVerDataStage2?.depth,
      //  "measurementCopy": this.PondVerDataStage2?.estimateCopy,
      //  "totalEstimatedCost": this.PondVerDataStage2?.estimateCost,
      //  "topBreadth": this.PondVerDataStage2?.topBreadth,
      //  "topLength": this.PondVerDataStage2?.topLength,
      //  "topSize": this.PondVerDataStage2?.topSize,
      //  "tankLat": this.PondVerDataStage2?.tankLat ? this.PondVerDataStage2?.tankLat : this.latPosition,
      //  "tankLng": this.PondVerDataStage2?.tankLng ? this.PondVerDataStage2?.tankLng : this.longPosition,


    }
    body.push(element);
    sessionStorage.setItem('pondReqBody', JSON.stringify(body));
  }

  // getGPSCoordinates() {
  //   this._getPosition().then((pos) => {
  //     this.latPosition = pos.lat;
  //     this.longPosition = pos.lng;
  //   });
  // }

  // _getPosition(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     navigator.geolocation.getCurrentPosition(
  //       (resp) => {
  //         resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
  //       },
  //       (err) => {
  //         reject(err);
  //       }
  //     );
  //   });
  // }

  images = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  openCamera() {
    this.displayCameraComponent = true;
  }

  onCloseCameraDialog() {
    this.displayCameraComponent = false;
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }


  public handleImage(webcamImage: WebcamImage): void {
    // console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    // console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    if (!this.insertPondAttachments) {
      this.insertPondAttachments = []
    }
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], "camera-captured" + '.jpeg', { type: mime })
    let data = new FormData();
    data.append('file', file);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    this.route.queryParams
      .subscribe(params => {
        this._personalDetalSer
          .uploadFile(data, phNo, "camera-captured")
          .subscribe((resp: any) => {
            if (resp.statusCode == 200) {
              const fileName = `tankPhotoStage1_${new Date().getTime()}`;
              this.insertPondAttachments.push({
                attachment: resp.data,
                attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                displayName: fileName,
              });

              let documentListObject = {
                'insertPondAttachments': this.insertPondAttachments
              }
              this.displayCameraComponent = false;
              this.imageCaptured = false;

            } else {
              // console.log('Error');
            }
          });
      }
      );
  }

  retake() {
    this.imageCaptured = false;
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  selectFarmerApplication(application) {
    if (application.appID) {
      // this.dashboard
      // .getMIDetailByAppID(application.appID)
      // .pipe(first())
      // .subscribe({
      //   next: (res) => {
      //     const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
      //     window.open(link, '_blank');
      //   },
      //   error: (err) => {
      //     console.log("error", err);
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error Message',
      //       detail: err,
      //     });
      //   },
      // });
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID)]));
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ], { queryParams: { appId: this.cryptoJsService.Encrypt(application.appID.toString()) } }));
      window.open(link, '_blank');
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (row.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (row.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }
  removeCaptureImg(index) {
    this.insertPondAttachments.splice(index, 1)
  }
  XENimageClick(index: number) {
    this.XENactiveIndex = index;
    this.XENdisplayCustom = true;
  }
  SDOimageClick(index: number) {
    this.SDOactiveIndex = index;
    this.SDOdisplayCustom = true;
  }
  getSurveyType(event) {
    this.selectedSurveyType = event;

    if(this.selectedSurveyType == 1){
      let val = '';
      if(this.xenLogin){
        val = 'xenLogin'
      }else if(this.sdoLogin){
        val = 'sdoLogin'
      }
      this.refreshLocation = setInterval(() => {
        this.onRefreshCurrentLocation(val);
      }, 5000);
    }else{
      if (this.refreshLocation) {
        clearTimeout(this.refreshLocation);
      }
    }
  }
  isEmpty(data: any) {
    if (data == null || data == undefined || data == '') {
      return true
    }
  }

  onCapture(val, index) {
    this.cdr.detectChanges();
    let instant = this;
    this.coordinateError = ''
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      function success(pos) {
        let isExist = false
        if (val == 'xenLogin') {
          isExist = instant.xengeolocationsarray[index].find(data => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude) {
              return data
            }
          })
        }
        else if (val == 'sdoLogin') {
          isExist = instant.sdogeolocationsarray[index].find(data => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude) {
              return data
            }
          })
        }
        else {
          isExist = instant.jegeolocationsarray[index].find((data) => {
            if (
              data.latitude == pos.coords.latitude &&
              data.longitude == pos.coords.longitude
            ) {
              return data;
            }
          });
        }
        if (isExist) {
          instant.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please move to a different location to get new coordinates.' });
        } else {
          const obj = {
            CornerID: val == 'xenLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.xengeolocationsarray[index].length + 1}` : val == 'sdoLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.sdogeolocationsarray[index].length + 1}` : `Polygon  ${index + 1} : Coordinate  ${instant.jegeolocationsarray[index].length + 1}`,
            cornerID: val == 'xenLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.xengeolocationsarray[index].length + 1}` : val == 'sdoLogin' ? `Polygon  ${index + 1} : Coordinate  ${instant.sdogeolocationsarray[index].length + 1}` : `Polygon  ${index + 1} : Coordinate  ${instant.jegeolocationsarray[index].length + 1}`,
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude
          }
          val == 'xenLogin' ? instant.xengeolocationsarray[index].push(obj) : val == 'sdoLogin' ? instant.sdogeolocationsarray[index].push(obj) : instant.jegeolocationsarray[index].push(obj)

          // Check for self-intersections before allowing the polygon creation
          if (instant.isSelfIntersecting(val == 'xenLogin' ? instant.xengeolocationsarray[index] : val == 'sdoLogin' ? instant.sdogeolocationsarray[index] : instant.jegeolocationsarray[index])) {
            // this.onDelect(this.geolocationsarray.length - 1);
            val == 'xenLogin' ? instant.xengeolocationsarray[index].pop() : val == 'sdoLogin' ? instant.sdogeolocationsarray[index].pop() : instant.jegeolocationsarray[index].pop()
            alert('Polygon is invalid due to intersecting edges. Please redraw.');
            return;
          } else {
            instant.onSave(val, index);
          }
        }
      }

      function error(err) {
      }
      navigator.geolocation.getCurrentPosition(success, error, options);
    }

  }

  onDrag(val, event) {
    if (val == 'xenLogin') {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.xengeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.xengeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.xengeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.xengeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.xenRemoveOverlay();
        this.xenAddOverlay();
        // this.removeOverlay();
        // this.addOverlay();
      }

    } else if (val == 'sdoLogin') {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.sdogeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.sdogeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.sdogeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.sdogeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.sdoRemoveOverlay();
        this.sdoAddOverlay();
        // this.removeOverlay();
        // this.addOverlay();
      }

    } else {
      let indexVal = this.getTableAndCoordinateVal(val, event?.overlay?.title)
      let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
      let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

      if (index >= 1) {
        this.jegeolocationsarray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
        this.jegeolocationsarray[tableNo - 1][index - 1].latitude = event?.overlay?.position?.lat();
        this.jegeolocationsarray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();
        this.jegeolocationsarray[tableNo - 1][index - 1].longitude = event?.overlay?.position?.lng();

        this.removeOverlay();
        this.addOverlay();
      }
    }

  }

  getTableAndCoordinateVal(loginType, val) {
    let polygonIndex = null; // Default to null if not present
    let coordinateValue = null; // Default to null if not present

    // Match both patterns
    const polygonMatch = val.match(/Polygon\s+(\d+)/);
    const coordinateMatch = val.match(/Coordinate\s+(\d+)/);

    // Extract polygon index if it exists
    if (polygonMatch) {
      polygonIndex = parseInt(polygonMatch[1], 10);
    }

    // Extract coordinate value if it exists
    if (coordinateMatch) {
      coordinateValue = parseInt(coordinateMatch[1], 10);
    }

    return { polygonIndex, coordinateValue };
  }

  removeOverlay() {
    this.jeMapoverlays.pop().setMap(null);
  }

  xenRemoveOverlay() {
    this.xenMapoverlays.pop().setMap(null);
  }

  sdoRemoveOverlay() {
    this.sdoMapoverlays.pop().setMap(null);
  }

  isSelfIntersecting(coordsArray) {
    for (let i = 0; i < coordsArray.length - 1; i++) {
      for (let j = i + 2; j < coordsArray.length; j++) {
        // Prevent checking consecutive edges or the last edge with the first one
        if (i === 0 && j === coordsArray.length - 1) continue;
        if (this.doLinesIntersect(coordsArray[i], coordsArray[i + 1], coordsArray[j], coordsArray[(j + 1) % coordsArray.length])) {
          return true;
        }
      }
    }
    return false;
  }

  doLinesIntersect(p1, q1, p2, q2) {
    // Helper function to calculate orientation of the points
    function orientation(p, q, r) {
      let val = (q.lat - p.lat) * (r.lng - q.lng) - (q.lng - p.lng) * (r.lat - q.lat);
      if (val === 0) return 0; // collinear
      return (val > 0) ? 1 : 2; // clock or counterclockwise
    }

    // Check the four orientations needed for the general and special cases
    let o1 = orientation(p1, q1, p2);
    let o2 = orientation(p1, q1, q2);
    let o3 = orientation(p2, q2, p1);
    let o4 = orientation(p2, q2, q1);

    // General case
    if (o1 !== o2 && o3 !== o4) return true;

    // Special cases
    // p1, q1, p2 are collinear and p2 lies on segment p1q1
    if (o1 === 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1, q2 are collinear and q2 lies on segment p1q1
    if (o2 === 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2, p1 are collinear and p1 lies on segment p2q2
    if (o3 === 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2, q1 are collinear and q1 lies on segment p2q2
    if (o4 === 0 && this.onSegment(p2, q1, q2)) return true;

    return false;
  }

  onSegment(p, q, r) {
    return q.lng <= Math.max(p.lng, r.lng) && q.lng >= Math.min(p.lng, r.lng) &&
      q.lat <= Math.max(p.lat, r.lat) && q.lat >= Math.min(p.lat, r.lat);
  }

  onDeleteCoordinate(loginType, i, tableNo) {
    if (loginType == 'xenLogin') {
      this.xengeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.xengeolocationsarray[tableNo].length; index++) {
        this.xengeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.xengeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
    else if (loginType == 'sdoLogin') {
      this.sdogeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.sdogeolocationsarray[tableNo].length; index++) {
        this.sdogeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.sdogeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
    else {
      this.jegeolocationsarray[tableNo].splice(i, 1);
      for (let index = 0; index < this.jegeolocationsarray[tableNo].length; index++) {
        this.jegeolocationsarray[tableNo][index].CornerID = `Polygon  ${tableNo + 1} : Coordinate  ${index + 1}`;
      }

      if (this.jegeolocationsarray[tableNo].length > 0) {
        this.onSave(loginType, tableNo);
      } else {
        this.onSave(loginType, 0);
      }
    }
  }

  onDeleteNewPolygon(loginType, i) {
    if (loginType == 'xenLogin') {
      if (i >= 0 && i < this.xengeolocationsarray.length) {
        this.xengeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.xengeolocationsarray.length; j++) {
          for (let k = 0; k < this.xengeolocationsarray[j].length; k++) {
            this.xengeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        console.error("Index out of bounds");
      }
    }
    else if (loginType == 'sdoLogin') {
      if (i >= 0 && i < this.sdogeolocationsarray.length) {
        this.sdogeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.sdogeolocationsarray.length; j++) {
          for (let k = 0; k < this.sdogeolocationsarray[j].length; k++) {
            this.sdogeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        console.error("Index out of bounds");
      }
    }
    else {
      if (i >= 0 && i < this.jegeolocationsarray.length) {
        this.jegeolocationsarray.splice(i, 1);

        // Renaming the remaining polygon corner IDs
        for (let j = 0; j < this.jegeolocationsarray.length; j++) {
          for (let k = 0; k < this.jegeolocationsarray[j].length; k++) {
            this.jegeolocationsarray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
          }
        }

        this.onSave(loginType, 0);

      } else {
        console.error("Index out of bounds");
      }
    }

  }

  onStartNewPolygon(loginType, index) {
    if (loginType == 'xenLogin') {
      this.xengeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
    else if (loginType == 'sdoLogin') {
      this.sdogeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
    else {
      this.jegeolocationsarray.push([]);
      this.cdr.detectChanges();
    }
  }

  onSave(val, tableNo) {
    this.coordinateError = '';
    this.mapEnable = false;
    this.mapEnable = true;
    if (val == 'xenLogin') {
      this.xenMapoptions.center = this.xengeolocationsarray[tableNo][0]
      this.xenMapoverlays = []
      this.xengeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.xenAddMarkers(row, index, tableIndex)
        })
      });
      this.xenAddOverlay()
    } else if (val == 'sdoLogin') {
      this.sdoMapoptions.center = this.sdogeolocationsarray[tableNo][0]
      this.sdoMapoverlays = []
      this.sdogeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.sdoAddMarkers(row, index, tableIndex)
        })
      });
      this.sdoAddOverlay()
    } else {
      this.jeMapoptions.center = this.jegeolocationsarray[tableNo][0]
      this.jeMapoverlays = []
      this.jegeolocationsarray.forEach((arr, tableIndex) => {
        arr.forEach((row, index) => {
          this.addMarkers(row, index, tableIndex)
        })
      });
      this.addOverlay()
    }


    sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
    sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
    sessionStorage.setItem('miPhysicalAppSDOGPSCoordinates', JSON.stringify(this.sdogeolocationsarray));

    // if(this.xenLogin && this.xengeolocationsarray && this.xengeolocationsarray > 3) {

    //   this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true)
    // } else if(this.jeLogin && this.jegeolocationsarray && this.jegeolocationsarray.length > 0){
    //   let jeArray: any = this.jegeolocationsarray;
    //   const jeMergedArray = jeArray.flat();
    //   let preEstimate: any = this.preEstimateCoordinates;
    //   const preEstimateMerge = preEstimate.flat();

    //   this.verifyCoordinates(preEstimateMerge, jeMergedArray, false)
    //   // this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false)
    // }
  }

  addMarkers(row: any, index, tableNo) {
    this.jeMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  addOverlay() {
    this.jegeolocationsarray.forEach(arr => {
      this.jeMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('jeLogin'), 1000);
  }

  xenAddOverlay() {
    this.xengeolocationsarray.forEach(arr => {
      this.xenMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('xenLogin'), 1000);
  }
  xenAddMarkers(row: any, index, tableNo) {
    this.xenMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  sdoAddOverlay() {
    this.sdogeolocationsarray.forEach(arr => {
      this.sdoMapoverlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })

    setTimeout(() => this.calculateSurveyArea('sdoLogin'), 1000);
  }
  sdoAddMarkers(row: any, index, tableNo) {
    this.sdoMapoverlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        draggable: false,
        // draggable: true,
        crossOnDrag: false
      })
    );
  }

  calculateSurveyArea(val) {
    let area = 0;
    if (val == 'xenLogin') {
      this.xengeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.xenSurveyLandArea = Number((0.000247105 * area).toFixed(2));

    } else if (val == 'sdoLogin') {
      this.sdogeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.sdoSurveyLandArea = Number((0.000247105 * area).toFixed(2));

    } else {
      this.jegeolocationsarray.forEach(array => {
        if (array.length >= 3) {
          let polygon = new google.maps.Polygon({ paths: array });
          area += this.calculateLandArea(polygon.getPath());
        }
      });
      this.jeSurveyLandArea = Number((0.000247105 * area).toFixed(2));
    }
  }

  calculateLandArea(polygon) {
    return google?.maps?.geometry?.spherical.computeArea(polygon)
  }

  onRefreshCurrentLocation(loginType) {
    if (loginType == 'xenLogin') {
      this.xenMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.xenMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
    if (loginType == 'sdoLogin') {
      this.sdoMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.sdoMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
    else {
      this.jeMapoverlays.forEach((val, index) => {
        if (val?.title == "Current Location") {
          this.jeMapoverlays.splice(index, 1);
        }
      })
      this.getCurrentLocation(loginType);
    }
  }

  getCurrentLocation(loginType) {
    let overlay;
    if (loginType == 'xenLogin') {
      overlay = this.xenMapoverlays;
    }
    else if (loginType == 'sdoLogin') {
      overlay = this.sdoMapoverlays;
    }
    else {
      overlay = this.jeMapoverlays;
    }

    let mapEnable = this.mapEnable;
    let instant = this;

    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        if (loginType == 'xenLogin') {
          instant.xenMapoptions.center = obj;
        }
        else if (loginType == 'sdoLogin') {
          instant.sdoMapoptions.center = obj;
        }
        else {
          instant.jeMapoptions.center = obj;
        }
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

        const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)


        if (loginType == 'xenLogin') {
          instant.mapEnableXEN = true;
        }
        else if (loginType == 'sdoLogin') {
          instant.mapEnableSDO = true;
        }
        else {
          instant.mapEnableJE = true;
        }
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if (err?.message == 'User denied Geolocation') {
          detailsMsg = 'Please enable Geolocation access.'
        } else {
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
    });
  }

  _getPosition(): Promise<any> {
    // this.loader.start();
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          // this.loader.close();
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          // this.loader.close();
          // reject(err);
        }
      );
    });
  }

  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
  }
}

